import { X } from 'lucide-react';

/**
 * A phone sheet's title row (mobile 5, 6, 7): × on the left, the title centred. Only on a touch
 * screen, where the menu it heads is a sheet.
 */
export function MobileSheetHeader({
  title,
  onClose,
  closeLabel = `Close ${title}`,
}: {
  title: string;
  onClose: () => void;
  closeLabel?: string;
}) {
  return (
    <div className="relative flex h-11 shrink-0 items-center justify-center" data-sheet-header>
      <button
        aria-label={closeLabel}
        className="absolute left-0.5 flex size-11 items-center justify-center rounded-control active:bg-control"
        onClick={onClose}
        onMouseDown={(event) => event.preventDefault()}
        type="button"
      >
        <X className="size-5" />
      </button>
      <h2 className="type-card-title">{title}</h2>
    </div>
  );
}
